import { t } from "@lingui/macro"
import { observer } from "mobx-react"
import { useCallback } from "react"

import { chatbot_MessageInfoSource } from "src/api"
import { AvyChat } from "src/components/Chat"
import { EAvyChatVariant } from "src/components/Chat/types/chat"
import { environment } from "src/config"
import { getKnowledgeItemSegmentUrl } from "src/helpers/knowledgeItemLinking"
import { reportError } from "src/lib/report"
import { ChatbotDetailStore } from "src/modals/chatbot/store"
import { useStore } from "src/store/lib/useStore"
import { IChatMessage } from "src/types/chat-message/chatMessage"

interface IProps {
    messages: IChatMessage[]
    isTranslationEnabled?: boolean
}

export const Transcript = observer((props: IProps) => {
    const store = useStore(ChatbotDetailStore)

    const openLink = useCallback((url: string) => {
        window.open(url, "_blank", "")
    }, [])

    const handleLinkClick = useCallback(
        (item?: chatbot_MessageInfoSource) => {
            if (item === undefined || item.object_type === undefined) {
                openLink("")
                return
            }

            const baseUrl = environment.BASE_URL
            const urlMap: Record<string, string> = {
                information_item: `${baseUrl}/library/information-items/${item.object_id}`,
                notice_board_message: `${baseUrl}/notice-board/${item.object_id}`,
            }

            if (
                item.object_type === "knowledge_item" &&
                item.object_id !== undefined &&
                item.object_id !== null &&
                item.object_id !== ""
            ) {
                const objectId = item.object_id
                ;(async () => {
                    try {
                        const segmentUrl = await getKnowledgeItemSegmentUrl(
                            objectId,
                        )
                        if (segmentUrl !== null) {
                            openLink(`${baseUrl}${segmentUrl}`)
                        } else if (
                            store.propertyObjectSegmentId !== undefined &&
                            store.propertyObjectSegmentId !== null &&
                            store.propertyObjectSegmentId > 0
                        ) {
                            openLink(
                                `${baseUrl}/chatbot/properties/${store.propertyObjectSegmentId}/${objectId}`,
                            )
                        } else {
                            reportError(
                                t`This knowledge item has no published segments and cannot be opened.`,
                            )
                        }
                    } catch (error) {
                        reportError(t`Failed to open knowledge item.`, error)
                    }
                })()
                return
            }

            if (urlMap[item.object_type] !== undefined) {
                openLink(urlMap[item.object_type])
            } else {
                openLink("")
            }
        },
        [openLink, store.propertyObjectSegmentId],
    )

    return (
        <AvyChat
            variant={EAvyChatVariant.Transcript}
            messages={props.messages}
            boxWrapperStyles={{
                padding: "16px",
                boxSizing: "border-box",
            }}
            handleSourceClick={handleLinkClick}
            isTranslationEnabled={props.isTranslationEnabled}
        />
    )
})
